import { Table, Box } from '@nimbus-ds/components';
import { TransferProductVariant } from 'domains/Catalog/Transfers/utils';

interface TransferVariantCellProps {
  productId: string;
  productVariants: TransferProductVariant[];
  showApplyValuesToAllVariants: Record<string, boolean>;
  renderProp: (
    variant: TransferProductVariant,
    totalVariants: number,
  ) => React.ReactNode;
}

function TransferVariantCell({
  productId,
  productVariants,
  showApplyValuesToAllVariants,
  renderProp,
}: Readonly<TransferVariantCellProps>) {
  const variants = productVariants.filter(
    (variant) => variant.productId === productId,
  );

  if (variants.length === 0) {
    return null;
  }

  return (
    <Table.Cell>
      <Box display="flex" flexDirection="column" gap="2" paddingRight="3">
        {variants.map((variant) => (
          <Box
            key={variant.variantId}
            height={
              showApplyValuesToAllVariants[variant.variantId] ? '78px' : '34px'
            }
            display="flex"
            alignItems="center"
            flexGrow="1"
          >
            {renderProp(variant, variants.length)}
          </Box>
        ))}
      </Box>
    </Table.Cell>
  );
}

export default TransferVariantCell;
